import React from 'react'

// Хэллоуинский декор только кодом: inline-SVG и CSS-анимации, без файлов картинок.

// Паутина в углу: радиальные нити из угла и провисающие дуги между ними
const WEB_SPOKES = [0, 15, 32, 50, 68, 90]
const WEB_RINGS = [28, 52, 80, 112, 148, 190]
const polar = (radius, degrees) => {
  const angle = (degrees * Math.PI) / 180
  return [radius * Math.cos(angle), radius * Math.sin(angle)]
}
const WEB_PATH = [
  ...WEB_SPOKES.map((angle) => {
    const [x, y] = polar(220, angle)
    return `M0 0 L${x.toFixed(1)} ${y.toFixed(1)}`
  }),
  ...WEB_RINGS.map((radius) => WEB_SPOKES.slice(1).map((angle, index) => {
    const prev = WEB_SPOKES[index]
    const [x1, y1] = polar(radius, prev)
    const [x2, y2] = polar(radius, angle)
    // Контрольная точка ближе к углу — нить провисает
    const [cx, cy] = polar(radius * 0.82, (prev + angle) / 2)
    return `${index === 0 ? `M${x1.toFixed(1)} ${y1.toFixed(1)}` : ''} Q${cx.toFixed(1)} ${cy.toFixed(1)} ${x2.toFixed(1)} ${y2.toFixed(1)}`
  }).join(' '))
].join(' ')

const CornerWeb = ({ side }) => (
  <svg className={`hw-web hw-web--${side}`} viewBox="0 0 220 220" aria-hidden="true">
    <path d={WEB_PATH} fill="none" stroke="rgba(225, 220, 245, 0.32)" strokeWidth="0.9" />
  </svg>
)

const Spider = () => (
  <div className="hw-spider">
    <div className="hw-spider-swing relative">
      <span className="hw-spider-thread" />
      <svg width="34" height="34" viewBox="0 0 40 40" aria-hidden="true">
        <g stroke="#1a1422" strokeWidth="2" strokeLinecap="round" fill="none">
          <path d="M16 20 C 9 14 6 12 2 13 M16 22 C 9 20 5 21 1 24 M16 24 C 10 26 7 29 4 34 M17 18 C 12 10 10 7 6 4" />
          <path d="M24 20 C 31 14 34 12 38 13 M24 22 C 31 20 35 21 39 24 M24 24 C 30 26 33 29 36 34 M23 18 C 28 10 30 7 34 4" />
        </g>
        <ellipse cx="20" cy="24" rx="7" ry="8" fill="#16111d" />
        <circle cx="20" cy="15" r="4.5" fill="#1d1626" />
        <circle cx="18.3" cy="14.5" r="1.1" fill="#ff5a1f" />
        <circle cx="21.7" cy="14.5" r="1.1" fill="#ff5a1f" />
      </svg>
    </div>
  </div>
)

// Летучая мышь: тело + крылья, крылья машут через scaleY
const Bat = ({ top, size, speed, delay }) => (
  <svg
    className="hw-bat"
    viewBox="0 0 100 44"
    style={{ '--hw-top': top, '--hw-size': size, '--hw-speed': speed, '--hw-delay': delay }}
    aria-hidden="true"
  >
    <path
      className="hw-bat-wing"
      fill="#0c0910"
      d="M50 22 C 40 6 26 2 4 8 C 12 12 14 18 12 24 C 18 20 24 22 26 28 C 30 22 38 22 42 28 C 44 24 47 23 50 22 Z M50 22 C 60 6 74 2 96 8 C 88 12 86 18 88 24 C 82 20 76 22 74 28 C 70 22 62 22 58 28 C 56 24 53 23 50 22 Z"
    />
    <ellipse cx="50" cy="24" rx="5" ry="8" fill="#0c0910" />
    <path d="M46 17 L47 12 L49 16 M54 17 L53 12 L51 16" fill="#0c0910" />
  </svg>
)

const BATS = [
  { top: '14%', size: '46px', speed: '19s', delay: '0s' },
  { top: '22%', size: '30px', speed: '23s', delay: '-6s' },
  { top: '9%', size: '24px', speed: '27s', delay: '-14s' }
]

// Детерминированные параметры искр, чтобы не прыгали между рендерами
const EMBERS = Array.from({ length: 16 }, (_, i) => ({
  x: `${(i * 61) % 100}%`,
  s: `${3 + (i % 4)}px`,
  d: `${9 + (i % 5) * 2}s`,
  delay: `-${(i * 1.7).toFixed(1)}s`,
  drift: `${((i % 7) - 3) * 14}px`
}))

export const DECOR = [
  { id: 'webs', name: 'Паутина' },
  { id: 'spider', name: 'Паук' },
  { id: 'bats', name: 'Летучие мыши' },
  { id: 'embers', name: 'Искры' },
  { id: 'lightning', name: 'Молнии' }
]

export const HalloweenDecor = ({ enabled }) => (
  <div className="hw-decor" aria-hidden="true">
    {enabled.lightning && <div className="hw-lightning" />}
    {enabled.webs && (
      <>
        <CornerWeb side="left" />
        <CornerWeb side="right" />
      </>
    )}
    {enabled.spider && <Spider />}
    {enabled.bats && BATS.map((bat, index) => <Bat key={index} {...bat} />)}
    {enabled.embers && EMBERS.map((ember, index) => (
      <span
        key={index}
        className="hw-ember"
        style={{ '--hw-x': ember.x, '--hw-s': ember.s, '--hw-d': ember.d, '--hw-delay': ember.delay, '--hw-drift': ember.drift }}
      />
    ))}
  </div>
)

// Тыква-фонарь: дольки градиентами, лицо светится и мерцает как свеча
export const Pumpkin = ({ className = '' }) => (
  <svg className={className} viewBox="0 0 200 180" role="img" aria-label="Тыква">
    <defs>
      <radialGradient id="hw-pumpkin-skin" cx="45%" cy="40%" r="65%">
        <stop offset="0%" stopColor="#ffab3d" />
        <stop offset="60%" stopColor="#f26a0c" />
        <stop offset="100%" stopColor="#8f3104" />
      </radialGradient>
      <radialGradient id="hw-pumpkin-fire" cx="50%" cy="60%" r="60%">
        <stop offset="0%" stopColor="#fff6c2" />
        <stop offset="45%" stopColor="#ffc533" />
        <stop offset="100%" stopColor="#ff6a00" />
      </radialGradient>
      <radialGradient id="hw-pumpkin-halo" cx="50%" cy="50%" r="50%">
        <stop offset="0%" stopColor="rgba(255, 130, 20, 0.45)" />
        <stop offset="100%" stopColor="rgba(255, 130, 20, 0)" />
      </radialGradient>
    </defs>
    <ellipse className="hw-pumpkin-glow" style={{ transformOrigin: '100px 105px' }} cx="100" cy="105" rx="100" ry="78" fill="url(#hw-pumpkin-halo)" />
    <path d="M96 38 C 94 24 100 14 112 8 L 116 14 C 108 18 105 26 106 38 Z" fill="#3f6b1f" />
    <ellipse cx="62" cy="104" rx="44" ry="58" fill="url(#hw-pumpkin-skin)" />
    <ellipse cx="138" cy="104" rx="44" ry="58" fill="url(#hw-pumpkin-skin)" />
    <ellipse cx="100" cy="104" rx="46" ry="62" fill="url(#hw-pumpkin-skin)" />
    <path d="M100 44 C 86 70 86 140 100 166 M100 44 C 114 70 114 140 100 166" stroke="rgba(110, 35, 0, 0.45)" strokeWidth="2" fill="none" />
    <g className="hw-pumpkin-face" fill="url(#hw-pumpkin-fire)">
      <path d="M58 86 L80 78 L76 100 Z" />
      <path d="M142 86 L120 78 L124 100 Z" />
      <path d="M92 106 L100 94 L108 106 Z" />
      <path d="M52 118 C 70 150 130 150 148 118 L134 124 L128 116 L118 128 L108 120 L100 132 L92 120 L82 128 L72 116 L66 124 Z" />
    </g>
  </svg>
)

// Ядовитая слизь на верхней кромке баннера
const DRIPS = [
  { x: '8%', w: '10px', l: '22px', d: '3.4s', delay: '0s' },
  { x: '23%', w: '7px', l: '14px', d: '2.8s', delay: '-1s' },
  { x: '41%', w: '12px', l: '30px', d: '4.2s', delay: '-2s' },
  { x: '63%', w: '8px', l: '18px', d: '3s', delay: '-0.5s' },
  { x: '81%', w: '11px', l: '26px', d: '3.8s', delay: '-1.6s' }
]

export const SlimeEdge = () => (
  <div aria-hidden="true">
    <div className="hw-slime" />
    {DRIPS.map((drip, index) => (
      <span
        key={index}
        className="hw-drip"
        style={{ '--hw-x': drip.x, '--hw-w': drip.w, '--hw-l': drip.l, '--hw-d': drip.d, '--hw-delay': drip.delay }}
      />
    ))}
  </div>
)
